import { type UpdatableSegmentStatus } from 'business/receipt/constants';
import type { UploadFile } from 'antd';

export enum QuarantineDefectOrientationEnum {
  Down = 'DOWN',
  Up = 'UP',
}

export type Position = {
  x: number;
  y: number;
};

export interface SegmentFormValues {
  segmentType: string;
  status: UpdatableSegmentStatus;
  // fields for quarantine
  quarantineType?: string;
  localization: QuarantineDefectOrientationEnum;
  position: Position;
  description?: string;
  pictures?: UploadFile[];
  // fields for rejection
  rejectionDescription?: string;
  rejectionPictures?: UploadFile[];
}
